import {
  AdminResourceDictPropertiesUpdateRequest,
  AdminResourceDictPropertiesUpdateResponse,
  AdminResourceDictPropertyCodeCheckCheckRequest,
  AdminResourceDictPropertyCodeCheckCheckResponse,
  AdminResourceDictPropertyCreateRequest,
  AdminResourceDictPropertyCreateResponse,
  AdminResourceDictPropertyDeleteRequest,
  AdminResourceDictPropertyDeleteResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export default class ResourcePropertiesService {
  public checkExists(
    request: AdminResourceDictPropertyCodeCheckCheckRequest
  ): Promise<AxiosResponse<AdminResourceDictPropertyCodeCheckCheckResponse>> {
    return axios.post<AdminResourceDictPropertyCodeCheckCheckResponse>('/api/admin/resources/dict/properties/check', request);
  }

  public create(request: AdminResourceDictPropertyCreateRequest): Promise<AxiosResponse<AdminResourceDictPropertyCreateResponse>> {
    return axios.post<AdminResourceDictPropertyCreateResponse>('/api/admin/resources/dict/properties/create', request);
  }

  public update(request: AdminResourceDictPropertiesUpdateRequest): Promise<AxiosResponse<AdminResourceDictPropertiesUpdateResponse>> {
    return axios.post<AdminResourceDictPropertiesUpdateResponse>('/api/admin/resources/dict/properties/update', request);
  }

  public delete(request: AdminResourceDictPropertyDeleteRequest): Promise<AxiosResponse<AdminResourceDictPropertyDeleteResponse>> {
    return axios.post<AdminResourceDictPropertyDeleteResponse>('/api/admin/resources/dict/properties/delete', request);
  }
}
